/****************************************************
 * Module Name:  businesstypeProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class BusinesstypeProxy {
  static GetAllBusinesstype = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/businesstype",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetSingleBusinesstype = (businesstypeId, callback) => {
    let params = {
      id: businesstypeId,
    };

    restAPICall(
      Constants.MANAGER_URL + "/businesstype",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static CheckBusinesstypeAvailable = (businesstype, callback) => {
    let params = {
      businesstype: businesstype,
    };

    restAPICall(
      Constants.MANAGER_URL + "/businesstype/available",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static AddBusinesstype = (businesstype, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/businesstype",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(businesstype),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UpdateBusinesstype = (businesstype, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/businesstype",
      "put",
      Constants.userToken,
      undefined,
      JSON.stringify(businesstype),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static DeleteBusinesstype = (businesstype, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/businesstype",
      "delete",
      Constants.userToken,
      undefined,
      JSON.stringify(businesstype),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };
}
